import React, {useState} from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileScreen, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';


const Education = () => {
  const { t, i18n } = useTranslation();
  
  const onPhoneClick = () => {
    console.log('phone click')
  }

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const mailTo = email => {
    window.location = 'mailto:'+email;
  };
  
  const phoneTo = number => {
    window.location = 'tel:'+number; //todo: only on smartphone
  };


  return (
    <div className='education'>
      <div className='inner-container'>
        {/* EDUCATION */}
        <h2 className='underline-title-white-blue'>{t('education.title')}</h2>
        <div className='content-block'>
          <h3 className='title'>{t('education.1.title')}</h3>
          <p className='text'>{t('education.1.text')}</p>
          <p className='date'>{t('education.1.date')}</p>
        </div>
        <div className='content-block'>
          <h3 className='title'>{t('education.2.title')}</h3>
          <p className='text'>{t('education.2.text')}</p>
          <p className='date'>{t('education.2.date')}</p>
        </div>

        {/* LANGUAGES */}
        <h2 className='underline-title-white-blue'>{t('languages.title')}</h2>
        <div className='content-block'>
          <h3 className='title'>{t('languages.1.title')}</h3>
          <p className='text'>{t('languages.1.text')}</p>
        </div>
        <div className='content-block'>
          <h3 className='title'>{t('languages.2.title')}</h3>
          <p className='text'>{t('languages.2.text')}</p>
        </div>
        
        {/* REFERENCES */}
        <h2 className='underline-title-white-blue'>{t('references.title')}</h2>
        <div className='content-block'>
          <h3 className='title'>{t('references.1.title')}</h3>
          <Trans
            i18nKey="references.1.text"
            components={{ br: <br /> }}
          />
          <p className='contact'>{t('references.1.contact')}</p>
        </div>
        <div className='content-block'>
          <h3 className='title'>{t('references.2.title')}</h3>
          <p className='text'>{t('references.2.text')}</p>
          <p className='contact'>{t('references.2.contact')}</p>
        </div>
        <div className='content-block'>
          <h3 className='title'>{t('references.3.title')}</h3>
          <p className='text'>{t('references.3.text')}</p>
          <p className='contact'>{t('references.3.contact')}</p>
        </div>
        
        <div className='contact-container'>
          <div className='content-block'>
            <button className='btn-icon' onClick={() => {phoneTo('+33685840276')}} type="button">
              <FontAwesomeIcon icon={faMobileScreen} />
            </button>
            <div className='content'>
              <h4 className='title'>{t('contact.1.title')}</h4>
              <p className='text'>{t('contact.1.text')}</p>
            </div>
          </div>
          <div className='content-block'>
            <button className='btn-icon' onClick={() => {mailTo('marie.baudlot@gmail.com')}} type="button">
            <FontAwesomeIcon icon={faEnvelope} />
            </button>
            <div className='content'>
              <h4 className='title'>{t('contact.2.title')}</h4>
              <p className='text'>{t('contact.2.text')}</p>
            </div>
          </div>
          <div className='content-block'>
            <button className='btn-icon' onClick={() => {openInNewTab('https://www.linkedin.com/in/mbaudlot/')}} type="button">
            <FontAwesomeIcon icon={faLinkedinIn} />
            </button>
            <div className='content'>
              <h4 className='title'>{t('contact.3.title')}</h4>
              <p className='text'>{t('contact.3.text')}</p>
            </div>
          </div>



        </div>
      </div>
    </div>
  );
};

export default Education;